@media screen and (max-width: 719px) {
  :host {
    padding: 0 16px;
  }
}

.products-pagination__desktop {
  width: 100%;
  text-align: center;
  margin-top: 36px;
}

.products-pagination__load-prev-btn {
  display: block;
  width: 100%;
  margin-bottom: 20px;
}

.products-pagination__load-more-btn {
  display: block;
  width: 100%;
  margin-top: 20px;
}

.products-pagination__total-count {
  color: #626469;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 12px;
}